import { render, staticRenderFns } from "./CustomerShowInvoice.vue?vue&type=template&id=5788c1b8"
import script from "./CustomerShowInvoice.vue?vue&type=script&lang=js"
export * from "./CustomerShowInvoice.vue?vue&type=script&lang=js"
import style0 from "./CustomerShowInvoice.vue?vue&type=style&index=0&id=5788c1b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports